import ErrorIcon from '../../../../assets/icons/alerts/error.svg?react'
import WarningIcon from '../../../../assets/icons/alerts/warning.svg?react'
import InfoIcon from '../../../../assets/icons/alerts/info.svg?react'
import SuccessIcon from '../../../../assets/icons/alerts/success.svg?react'
import css from './alertBlock.module.css'
import CloseButton from '../../../../shared/Buttons/CloseButton'
import { IAlert } from '@/services/alerts/alertTile.types'
import { CSSProperties } from 'react'

interface IProps extends Partial<Omit<IAlert, 'type'>>, Pick<IAlert, 'type'> {
  onCancel?: () => void
  style?: CSSProperties
}

const AlertBlock = (props: IProps) => {
  const renderIcon = () => {
    switch (props.type) {
      case 'success':
        return <SuccessIcon className={css.icon} />
      case 'error':
        return <ErrorIcon className={css.icon} />
      case 'info':
        return <InfoIcon className={css.icon} />
      case 'warning':
        return <WarningIcon className={css.icon} />
    }
  }

  return (
    <div data-type={props.type} className={css.wrapper} style={props.style}>
      {props.onCancel && (
        <div className={css.closeIconWrapper}>
          <CloseButton iconStyle={{ color: 'var(--text-description)' }} onClick={props.onCancel} />
        </div>
      )}
      <div className="inline-flex-gap top">
        {renderIcon()}
        <div className="flex-lines gap4">
          <p className="text-lg">{props.title}</p>
          <p className="text-nm">{props.description}</p>
        </div>
      </div>
    </div>
  )
}

export default AlertBlock
